module.exports = __webpack_public_path__ + "img/09-payroll-view.a3a75ee5.png";